import { useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { removeHtmlTags } from '@portal-internet/core';
import Compartir from 'components/3cat/Compartir';
import Imatge, { getPeu, getImatge } from 'components/3cat/Imatge';
import Player from 'components/3cat/Player';
import Text from 'components/3cat/Text';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './itemnoticia.module.scss';
import { useRouter } from 'next/router';

export default function ItemNoticia(props) {
    const {
        id,
        cos,
        codiEspectador,
        data_publicacio,
        data_modificacio,
        redactor,
        titol,
        avantitol,
        mediadestacats,
        imatges,
        videos,
        audios,
        social,
        className,
        isWebviewActive,
        autors
    } = props;
    const entradeta = removeHtmlTags(props.entradeta);
    const [renderCos, setRenderCos] = useState(<></>);
    const router = useRouter();

    let autor, autorTwitter, autorImatge, autorImatgeAlt;

    const stylesNoticia = clsx({
        [styles.itemnoticia]: true,
        [styles[className]]: !__isEmpty(className)
    });

    if (autors !== undefined) {
        autor = autors[0]?.desc;
        autorTwitter = autors[0]?.twitter;
        autorImatge = getImatge(autors[0]?.imatges, 'web_autor');
        autorImatgeAlt = autors[0]?.imatges?.[0].alt;
    }

    const getCosWithCodiEspectador = () => {
        let codiEdat = codiEspectador?.id?.replace('PUCE_', '').replace('CE_', '').replace(/^0+/, '');
        if (codiEdat === 'IN') {
            codiEdat = 'TP';
        }

        if (__isEmpty(codiEdat) || codiEdat === 'TP') return cos;

        const codiSrc = '/_resources/icones/codisEspectador/codisEspectador' + codiEdat + '.svg?v=2.2512.2';

        const codi = ReactDOMServer.renderToString(
            <span className={styles.contenidorCodiEspectador}>
                <img
                    src={codiSrc}
                    alt={codiEspectador.desc}
                    loading='lazy'
                    className={styles.codiEspectador}
                    width='28'
                    height='28'
                />
            </span>
        );

        const cosHtml = document.createElement(null);
        cosHtml.innerHTML = cos;

        if (!cosHtml.querySelector('p')) {
            cosHtml.innerHTML = `<p>${cos}</p>`;
        }

        cosHtml.querySelector('p').insertAdjacentHTML('afterbegin', codi);

        return cosHtml.innerHTML;
    };
    const dateFormat = (date) => {
        if (__isEmpty(date)) return null;
        const dateSplit = date.split(' ');
        const timeSplit = dateSplit[1]?.split(':');
        const dateFormatted = dateSplit[0] + ' - ' + timeSplit[0] + '.' + timeSplit[1];
        return dateFormatted;
    };
    const getSignature = () => {
        return (
            <>
                {autorImatge && (
                    <div className={styles.autor_foto}>
                        <Imatge
                            imatges={autors[0].imatges}
                            src={`${autorImatge}`}
                            tipus='web_autor'
                            alt={`${autorImatgeAlt}`}
                            layout='fill'
                            objectFit='cover'
                            crop='64x64'
                        />
                    </div>
                )}

                {autor && (
                    <div className={styles.autor}>
                        <p className={styles.autor_redactor}>{autor}</p>
                        {autorTwitter && (
                            <a
                                className={styles.autor_xarxa}
                                href={`https://twitter.com/${autorTwitter}`}
                                title={`Compte X - ${autor}`}
                            >
                                {autorTwitter}
                            </a>
                        )}
                    </div>
                )}
            </>
        );
    };
    const getDataPublicacio = () => {
        return (
            <>
                <div>
                    {!autor && redactor && <p className={styles.redactor}>{redactor}</p>}
                    <p className={styles.data_pub}>
                        {dateFormat(data_publicacio)}{' '}
                        {data_modificacio && <span>Actualitzat {dateFormat(data_modificacio)}</span>}
                    </p>
                </div>
                <Compartir titol={titol} mida='32' isWebviewActive={isWebviewActive} />
            </>
        );
    };
    // Busquem iframes incrustats tipus embed notícia relacionada
    // i concatenem a cada url un querystring
    // El mòdul destacat (jitpub1) aplicarà un class i uns estils css específics
    const iframesIncrustats = () => {
        const allIframes = document.getElementsByClassName('C-embed-dinsNoticia');
        return Array.from(allIframes).map((element) => {
            element.src = element.src + '?embed3cat=3catinfo';
        });
    };

    useEffect(() => {
        if (!cos) return;

        setRenderCos(<Text className={styles.cos} text={getCosWithCodiEspectador()} />);
        const timer = setTimeout(() => {
            iframesIncrustats(), 5000;
        });
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.asPath, cos]);

    const getMediaDestacat = () => {
        if (mediadestacats === 'VIDEO' && !__isEmpty(videos) && !isWebviewActive) {
            return (
                <div className={styles.media} data-testid='noticia-media-video'>
                    <div className={styles.video}>
                        <Player id={videos[0].id} />
                    </div>
                </div>
            );
        } else if (mediadestacats === 'AUDIO' && !__isEmpty(audios) && !isWebviewActive) {
            return (
                <div className={styles.media} data-testid='noticia-media-audio'>
                    <div className={styles.audio}>
                        <Player id={audios[0].id} tipus='audio' estils='noticia' />
                    </div>
                </div>
            );
        } else if (!__isEmpty(imatges)) {
            const peu = getPeu(imatges, 'web_destacat');
            return (
                <div className={styles.media} data-testid='noticia-media-imatge'>
                    <Imatge
                        className={styles.imatge}
                        imatges={imatges}
                        tipus='web_destacat'
                        alt={titol}
                        layout='fill'
                        objectFit='cover'
                        loading='eager'
                        priority={true}
                    />
                    {peu && (
                        <div className={styles.peuFoto} data-testid='noticia-media-peu'>
                            {peu}
                        </div>
                    )}
                </div>
            );
        }
    };
    return (
        <div className={stylesNoticia}>
            <div className={styles.capcalera}>
                {avantitol && <p className={styles.avantitol}>{avantitol}</p>}
                {titol && <h1 className={styles.titol}>{titol}</h1>}
                {entradeta && <h3 className={styles.entradeta}>{entradeta}</h3>}
            </div>
            {autor && <div className={styles.autor_wrapper}>{getSignature()}</div>}
            {social && <div className={styles.info}>{getDataPublicacio()}</div>}

            {getMediaDestacat()}
            {renderCos}
        </div>
    );
}

ItemNoticia.defaultProps = {
    titol: '',
    social: true,
    isWebviewActive: false
};
